export default __webpack_public_path__ + "static/media/Quarto-Medium.62194784.woff2";